import type { ReactElement } from 'react';
import {
  Add as AddIcon,
  ArchiveOutlined as ArchiveIcon,
  AutoAwesomeOutlined as AutoAwesomeIcon,
  ContentCopy as CopyIcon,
  Delete as DeleteIcon,
  DeleteOutline as DeleteOutlineIcon,
  DeleteSweep as DeleteSweepIcon,
  Edit as EditIcon,
  FileDownload as ExportIcon,
  FileUpload as ImportIcon,
  PersonAddOutlined as PersonAddIcon,
  PictureAsPdf as PdfIcon,
  Refresh as RefreshIcon,
  FilterAltOff as ResetFiltersIcon,
  Save as SaveIcon,
  Settings as SettingsIcon,
  Undo as UndoIcon,
  ViewColumn as ViewColumnIcon,
} from '@mui/icons-material';
import type { Command } from '../../menu/types';
import { getCommandId } from '../commands/utils';

const commandIconMap: Record<string, ReactElement> = {
  add: <AddIcon />,
  addrelations: <PersonAddIcon />,
  archive: <ArchiveIcon />,
  save: <SaveIcon />,
  revert: <UndoIcon />,
  refresh: <RefreshIcon />,
  resetfilters: <ResetFiltersIcon />,
  export: <ExportIcon />,
  exporttopdf: <PdfIcon />,
  import: <ImportIcon />,
  delete: <DeleteIcon />,
  edit: <EditIcon />,
  copyrow: <CopyIcon />,
  deleteentities: <DeleteIcon />,
  showdeleted: <DeleteSweepIcon />,
  columnchooser: <ViewColumnIcon />,
  zsitecommandsavegridstate: <SettingsIcon />,
  implementwithai: <AutoAwesomeIcon />,
};

export const getCommandIcon = (command: Command): ReactElement | undefined => {
  return commandIconMap[getCommandId(command)];
};

export type DetailActionPresentation = {
  icon?: ReactElement;
  menuOnly: boolean;
  destructive: boolean;
};

export const getDetailActionPresentation = (command: Command): DetailActionPresentation => {
  const commandId = getCommandId(command);

  return {
    icon:
      commandId === 'archive' ? (
        <ArchiveIcon />
      ) : commandId === 'delete' ? (
        <DeleteOutlineIcon />
      ) : (
        getCommandIcon(command)
      ),
    menuOnly: commandId === 'archive' || commandId === 'delete',
    destructive: commandId === 'delete',
  };
};
